<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-text-field
                      v-model="name"
                      name="name"
                      label="Name"
                      :counter="100"
                      v-validate="'required|max:100'"
                      data-vv-as="Name"
                      :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-menu
                      v-model="menu.dateOfBirth"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                          v-model="dateOfBirth"
                          label="Date of Birth"
                          name="dateOfBirth"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          data-vv-as="Date of Birth"
                          v-validate="'required'"
                          :error-messages="errors.collect('dateOfBirth')"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dateOfBirth" @input="menu.dateOfBirth = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                      v-model="address"
                      name="address"
                      label="Address"
                      :counter="500"
                      v-validate="'required|max:500'"
                      data-vv-as="Address"
                      :error-messages="errors.collect('address')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                      v-model="language"
                      name="language"
                      label="Language"
                      :counter="500"
                      v-validate="'required|max:500'"
                      data-vv-as="Language"
                      :error-messages="errors.collect('language')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-textarea
                      v-model="training"
                      name="training"
                      label="Training"
                      :counter="1000"
                      v-validate="'required|max:1000'"
                      data-vv-as="Training"
                      :error-messages="errors.collect('training')"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md6>
                  <v-textarea
                      v-model="experience"
                      name="experience"
                      label="Experience"
                      :counter="2000"
                      v-validate="'required|max:2000'"
                      data-vv-as="Experience"
                      :error-messages="errors.collect('experience')"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md6>
                  <v-textarea
                      v-model="designation"
                      name="designation"
                      label="Designation"
                      :counter="1000"
                      v-validate="'required|max:1000'"
                      data-vv-as="Designation"
                      :error-messages="errors.collect('designation')"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md1>
                  <v-btn color="info" type="button" @click="imagePicked">
                    <v-icon>cloud_upload</v-icon>
                    Image
                  </v-btn>
                  <input
                      type="file"
                      style="display: none"
                      ref="ImageUploader"
                      accept="image/*"
                      @change="onImagePicked"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <vue-cropper
                      ref="cropper"
                      :aspect-ratio="ratio"
                      :src="mainImage"
                      :imageSmoothingEnabled="false"
                      alt="Upload Image"
                  ></vue-cropper>
                  <!-- <img :src="image" style="width:100%" v-if="image" /> -->
                  <br />
                  <v-btn color="info" type="button" @click="crop" v-if="showCrop">
                    <v-icon>crop</v-icon>
                    Crop
                  </v-btn>
                </v-flex>
                <v-flex xs12 md4>
                  <img v-if="image" :src="image" alt="Cropped Image" style="width:100%" />
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>
                Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from '../../store'
import commonservice from '../../shared/common.service'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  components: { VueCropper },
  computed: {
    name: {
      get() {
        return this.$store.state.fieldStaff.entity.name
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'name',
          value: val,
        })
      },
    },
    language: {
      get() {
        return this.$store.state.fieldStaff.entity.language
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'language',
          value: val,
        })
      },
    },
    address: {
      get() {
        return this.$store.state.fieldStaff.entity.address
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'address',
          value: val,
        })
      },
    },
    dateOfBirth: {
      get() {
        return this.$store.state.fieldStaff.entity.dateOfBirth
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'dateOfBirth',
          value: val,
        })
      },
    },
    training: {
      get() {
        return this.$store.state.fieldStaff.entity.training
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'training',
          value: val,
        })
      },
    },
    experience: {
      get() {
        return this.$store.state.fieldStaff.entity.experience
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'experience',
          value: val,
        })
      },
    },
    designation: {
      get() {
        return this.$store.state.fieldStaff.entity.designation
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'designation',
          value: val,
        })
      },
    },
    image: {
      get() {
        return this.$store.state.fieldStaff.entity.image
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', {
          key: 'image',
          value: val,
        })
      },
    },
    mainImage: {
      get() {
        return this.$store.state.fieldStaff.mainImage
      },
      set(val) {
        this.$store.commit('fieldStaff/SET_DATA', val)
      },
    },
  },
  data() {
    return {
      pageTitle: 'Add Field Staff',
      loading: false,
      menu: {
        publishDate: false,
      },
      menu1: false,
      ratio: 1.29,
      showCrop: false,
      editorOption: {
        // some quill options
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store.dispatch('fieldStaff/set', { id: to.params.id }).then(() => {
        next(p => {
          p.pageTitle = 'Edit Field Staff'
        })
      })
    } else {
      next(p => {
        p.reset()
      })
    }
  },
  methods: {
    submit() {
      if (this.loading) return
      if (this.image == null) {
        commonservice.showErrorMessage('Please upload image')
        return
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('fieldStaff/save').then(
              () => {
                commonservice.showSuccessMessage('Field Staff saved successfully')
                this.$router.push('/fieldStaff')
                this.loading = false
              },
              () => {
                this.loading = false
              },
          ).catch(() => {
            this.loading = false
          })
        }
      })
    },
    reset() {
      this.$store.commit('fieldStaff/RESET')
      setTimeout(() => {
        this.errors.clear()
      }, 10)
    },
    remove(item) {
      console.log(item)
      // this.chips.splice(this.chips.indexOf(item), 1);
      // this.chips = [...this.chips];
    },
    imagePicked() {
      this.$refs.ImageUploader.click()
    },
    crop() {
      var self = this
      // get image data for post processing, e.g. upload or setting image src
      var cropIm = self.$refs.cropper.getCroppedCanvas({ imageSmoothingEnabled: false }).toDataURL('image/jpeg', 0.7)
      self.$store.commit('fieldStaff/SET_DATA', {
        key: 'image',
        value: cropIm,
      })
    },
    onImagePicked(event) {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      var self = this
      reader.onload = function () {
        self.$store.commit('fieldStaff/SET_MAIN_IMAGE', reader.result)
        self.$refs.cropper.replace(reader.result)
        self.showCrop = true
      }
    },
  },
}
</script>
